module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"")
    ; __append(escapeFn( bgCss ))
    ; __append("\">\n	<div class=\"gl-header__icon icon-24 ")
    ; __append(escapeFn( css ))
    ; __append("\" on-click=\"")
    ; __append(escapeFn( locals["on-click"] ))
    ; __append("\"></div>\n</div>\n")
  }
  return __output.join("");

}